import { ChatBubbleEmpty } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconChatBubbleEmpty12Line = createIcon(
  ChatBubbleEmpty,
  12,
  "Line"
);
export const IconChatBubbleEmpty16Line = createIcon(
  ChatBubbleEmpty,
  16,
  "Line"
);
export const IconChatBubbleEmpty20Line = createIcon(
  ChatBubbleEmpty,
  20,
  "Line"
);
export const IconChatBubbleEmpty24Line = createIcon(
  ChatBubbleEmpty,
  24,
  "Line"
);
export const IconChatBubbleEmpty32Line = createIcon(
  ChatBubbleEmpty,
  32,
  "Line"
);
export const IconChatBubbleEmpty48Line = createIcon(
  ChatBubbleEmpty,
  48,
  "Line"
);
export const IconChatBubbleEmpty64Line = createIcon(
  ChatBubbleEmpty,
  64,
  "Line"
);
